<template>
<div>
    <el-card>
    <el-form :model="medicalList" label-width="100px">
    <el-row>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="主诉">
              <el-input
                type="textarea"
                :rows="6"
                v-model="medicalList.zhusu"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="现病史">
              <el-input
                type="textarea"
                :rows="6"
                v-model="medicalList.xianbing"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="过敏史">
              <el-input
                type="textarea"
                :rows="6"
                v-model="medicalList.guomin"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="辅助检查结果">
              <el-input
                type="textarea"
                :rows="6"
                v-model="medicalList.fuzhu"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="诊断">
              <el-input
                type="textarea"
                :rows="6"
                v-model="medicalList.diagnosis"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="处理">
              <el-input
                type="textarea"
                :rows="6"
                v-model="medicalList.chuli"
              >
                <!-- v-model="recipeOrderInfoList" -->
              </el-input>
            </el-form-item>
          </div></el-col
        >
      </el-row>
    </el-form>
    </el-card>
      </div>
</template>
<script>
export default {
    data(){
        return{
            medicalList:{}
        }
    },
    mounted(){
        this.medicalList=JSON.parse(window.localStorage.getItem("medicalList"));
    },
    methods:{

    }
}
</script>
<style>

</style>